import { render, staticRenderFns } from "./string-row.vue?vue&type=template&id=1c842928"
import script from "./string-row.vue?vue&type=script&lang=js"
export * from "./string-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports